/** @prettier */

/**
 * オートコンプリート テキストボックス
 */

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useTranslation} from 'react-i18next';

//Style import
import '../css/common/common.css';

/**
 * オートコンプリート テキストボックス
 * @param {string[]} data 選択できる項目
 * @param {(arg0: string | null) => void} setValue 値が変更された時の処理
 * @param {string | null} value 選択された値。
 * @param {string} id ID
 */
export default function ComboBox(props: {
  data: string[];
  setValue: React.Dispatch<React.SetStateAction<string | null>>;
  value: string | null;
  id?: string;
  class?: string;
}) {
  const trans = useTranslation().t; //翻訳関数

  return (
    <Autocomplete
      id={props.id}
      className={props.class}
      //選択項目
      options={props.data}
      //入力欄のレンダリング
      renderInput={params => (
        <TextField
          {...params}
          label={`${trans('AutoCompleteBox.txtField.label.timezone')}*`}
          variant="standard"
        />
      )}
      //文字を補完するかどうか
      autoComplete={true}
      //選択した項目を候補に表示するかどうか
      filterSelectedOptions={true}
      //候補がない場合の表示する値
      noOptionsText={trans('AutoCompleteBox.noOptionsTxt')}
      //選択時の処理
      onChange={(event: any, newValue: string | null) => {
        props.setValue(newValue);
      }}
      //入力欄に表示する値
      value={props.value}
    />
  );
}
